<template>
	<div class="form-group">
		<label v-if="name && hideName === false" class="control-label" :for="uniqueId"> {{ $t('label.' + name) }} <small v-if="crequired">*</small></label>
		<div>
				<input
					type="text"
					class="form-control"
					:class="{'is-danger': errors.length > 0}"
					:placeholder="cplaceholder"
					:id="uniqueId"
					:value="value"
					@input="$emit('input', $event.target.value)">
				<span v-show="errors.length > 0" v-for="error in errors" class="help is-danger">{{ error }}</span>
		</div>
	</div>
</template>

<script>

module.exports = {
	name: 'f-input',
	props: {
		value: {type: [Number, String], default: ''},
		name: {type: String},
		hideName: {type: null, default: false},
		cplaceholder: {type: String, default: ''},
		crequired: {type: Boolean, default: false},
		errors: {type: Array, default: () => ([])}
	},
	data: () => ({
		uniqueId: 'input-' + Math.random().toString(16).slice(2)
	})
};
</script>



// WEBPACK FOOTER //
// f-input.vue?29e7e5f4